export enum LOCALE {
	UK = 'UK',
}
